import { useCallback } from 'react';

import { useIsMobileApp } from 'hooks/useIsMobileApp';
import type { UserEngagementScoreIncrement_Source } from 'protos/webview/channel/native_messages';

export const useSendUserEngagementIncrement = () => {
  const { isMobileApp, postMessage } = useIsMobileApp();

  const sendUserEngagementIncrement = useCallback(
    (score: number, source: UserEngagementScoreIncrement_Source) => {
      if (isMobileApp && score)
        postMessage('userEngagementScoreIncrement', {
          score,
          source,
        });
    },
    [isMobileApp, postMessage]
  );

  return {
    sendUserEngagementIncrement,
  };
};
